module.exports = __webpack_public_path__ + "img/map_img.2c2eccb6.png";